import { getLinksFromUnescapeHTML, unescapeHTML } from '../../utils';
import type { WebDriver } from '../webdriver';
import type { TestimServicesApi } from 'clickim/src/common/TestimServicesApi';
import type { IStepActionUtils } from 'clickim/src/background/stepActions/stepActionUtils';

/**
 * Dummy class to match weird interface with web
 * Most of this is not used
 * */
export class MobileStepActionUtils implements IStepActionUtils {
    // @ts-expect-error value is set in the sessionPlayer's constructor
    public readonly testimServicesApi: TestimServicesApi;
    private readonly _abortedSteps: any[] = [];

    constructor(public readonly driver: WebDriver) {}

    resetAbort() {
        this._abortedSteps.length = 0;
    }

    abort(result: any) {
        this._abortedSteps.push(result);
    }

    get abortedSteps() {
        return this._abortedSteps;
    }

    async executeInAut(context: any, code: string) {
        throw new Error('not implemented (mobile)');
    }

    extractTargetText(target: never): Promise<any> {
        throw new Error('not implemented (mobile)');
    }

    getCookie(name: string): any {
        throw new Error('not implemented (mobile)');
    }

    setCookie(cookieObject: never): any {
        throw new Error('not implemented (mobile)');
    }

    async getNextDynamicParent(frameHandler: never, dynamicParentOptions: never): Promise<never> {
        throw new Error('not implemented (mobile)');
    }

    public unescapeHTML = unescapeHTML;

    public getLinksFromUnescapeHTML = getLinksFromUnescapeHTML;
}
